import type { FunctionComponent } from 'react';
import { Suspense } from 'react';

import {
  ChunkLoadErrorBoundary,
  ErrorBoundary,
} from '@trello/error-boundaries';
import { useLazyComponent } from '@trello/use-lazy-component';

import type { ListColorPickerProps } from './ListColorPicker';
import { ListColorPickerSkeleton } from './ListColorPickerSkeleton';

export const LazyListColorPicker: FunctionComponent<ListColorPickerProps> = (
  props,
) => {
  const ListColorPicker = useLazyComponent(
    () =>
      import(/* webpackChunkName: "list-color-picker" */ './ListColorPicker'),
    { namedImport: 'ListColorPicker' },
  );

  return (
    <ErrorBoundary
      tags={{
        ownershipArea: 'trello-web-eng',
        feature: 'List Color Picker',
      }}
    >
      <ChunkLoadErrorBoundary fallback={null}>
        <Suspense fallback={<ListColorPickerSkeleton />}>
          <ListColorPicker {...props} />
        </Suspense>
      </ChunkLoadErrorBoundary>
    </ErrorBoundary>
  );
};
